import React from 'react'
import ReactDOM from 'react-dom/client'
import {Provider} from 'react-redux'
import {PersistGate} from 'redux-persist/integration/react'
import {persistStore} from 'redux-persist'
import {BrowserRouter} from 'react-router-dom'
import {ENDPOINT} from 'config/path'
import App from 'App'
// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
import * as dotenv from './dotenv'

import {store} from './redux/store'
import './assets/scss/main.scss'

import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'

import {datadogRum} from '@datadog/browser-rum'
import {CacheProvider} from '@emotion/react'
import createCache from '@emotion/cache'
// webpack runtime expects this exact global name for nonce propagation.
// eslint-disable-next-line @typescript-eslint/naming-convention, prefer-const
declare let __webpack_nonce__: string | undefined

const nonce = document.querySelector('meta[name="csp-nonce"]')?.getAttribute('content') ?? undefined
// eslint-disable-next-line prefer-const, no-unused-vars, @typescript-eslint/no-unused-vars
__webpack_nonce__ = nonce
const cache = createCache({
    key: 'mui',
    nonce,
    prepend: true
})

const persistor = persistStore(store)
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

datadogRum.init({
    applicationId: process.env.REACT_APP_DATADOG_APPLICATION_ID ?? '',
    clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN ?? '',
    site: process.env.REACT_APP_DATADOG_SITE,
    service: process.env.REACT_APP_DATADOG_SERVICE,
    env: process.env.REACT_APP_DATADOG_ENV,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask'
})

root.render(
    <CacheProvider value={cache}>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <BrowserRouter basename={ENDPOINT.basePath}>
                    <App />
                </BrowserRouter>
            </PersistGate>
        </Provider>
    </CacheProvider>
)
